module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/e-photo-studio-og-image-47aaf1770b8dbe5621e1a60fd79d297b.jpg";